import { render, staticRenderFns } from "./opinion.vue?vue&type=template&id=4c94c654&scoped=true"
import script from "./opinion.vue?vue&type=script&lang=js"
export * from "./opinion.vue?vue&type=script&lang=js"
import style0 from "./opinion.vue?vue&type=style&index=0&id=4c94c654&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c94c654",
  null
  
)

export default component.exports